import React           from 'react';
import classNames      from 'classnames';
import PropTypes       from 'prop-types'
import { START }       from 'pu-data/QuoteSteps';
import PriceMatrixCell from './PriceMatrixCell'

const QuantityCell = (props) => {
  if (props.hideQuantityCell) return null;

  return (
    <td
      key={props.quantity}
      className="qty"
      rowSpan={props.rowSpanQuantityCell}>{props.quantity}
    </td>
  )
}

QuantityCell.propTypes = {
  hideQuantityCell: PropTypes.bool.isRequired,
  quantity: PropTypes.number.isRequired,
  rowSpanQuantityCell: PropTypes.number.isRequired,
}

const UsCombinedCells = (props) => {
  const { usCombined, quantity, groupName } = props
  if (!usCombined) return null;

  const cells = usCombined.lead_times.map((leadTime, col) => {
    const price = usCombined.matrix[quantity.toString()][groupName][leadTime.toString()]
    return (
      <PriceMatrixCell
        key={col}
        price={price}
        leadTime={leadTime}
        parameters={props.parameters}
        parametersChanged={props.parametersChanged}
        quantity={quantity}
        quoteStep={props.quoteStep}
        onPriceSelect={props.onPriceSelect} />
    )
  })

  return (<React.Fragment>{cells}</React.Fragment>)
}

UsCombinedCells.propTypes = {
  usCombined: PropTypes.object.isRequired,
  quantity: PropTypes.number.isRequired,
  groupName: PropTypes.string.isRequired,
  parameters: PropTypes.object.isRequired,
  parametersChanged: PropTypes.bool.isRequired,
  quoteStep: PropTypes.string.isRequired,
  onPriceSelect: PropTypes.func.isRequired,
}

const shouldDrawRow = (props) => {
  // const { priceRow } = props;
  const { quantity, usCombined, groupName } = props

  const usPriceRow = usCombined.matrix[quantity.toString()][groupName]
  return !!usPriceRow;
}

const PriceMatrixRow = (props) => {
  // let cells = [];
  const { showSummary, parameters, priceRow } = props

  // dont draw grpa row on start quote
  if (props.groupName === 'grpa' && props.quoteStep === START) return null;

  if (!shouldDrawRow(props)) return null;

  // cells = _.concat(cells, generateQuantityCell(props))
  // cells = _.concat(cells, generateUsCombinedCells(props))
  // cells = _.concat(cells, generateMakerCells(props))

  const klassRow = {
    'row-best-price': props.groupName === 'grpa',
    'row-customer-price': props.groupName !== 'grpa',
  }

  let includePriceSeleted = false
  if (showSummary) {
    const foundLeadTime = Object.keys(priceRow).find((leadTime) => {
      const price = priceRow[leadTime]
      if (!price || !parameters.row_selected == null || parameters.column_selected == null)
        return false

      return price && price.row_line_item === parameters.row_selected && price.col_line_item === parameters.column_selected && price.quote_config_key === parameters.quote_config_key
    })
    includePriceSeleted = foundLeadTime !== undefined
  }

  klassRow['d-none'] = showSummary === true && !includePriceSeleted
  const hideQuantityCell = (showSummary === false && props.hideQuantityCell) || (showSummary === true && !includePriceSeleted)
  const rowSpan = showSummary === false ? props.rowSpanQuantityCell : 1


  return (
    <tr className={classNames(klassRow)}>
      <QuantityCell
        hideQuantityCell={hideQuantityCell}
        quantity={props.quantity}
        rowSpanQuantityCell={rowSpan} />
      <UsCombinedCells
        quantity={props.quantity}
        quoteStep={props.quoteStep}
        parameters={props.parameters}
        groupName={props.groupName}
        parametersChanged={props.parametersChanged}
        usCombined={props.usCombined}
        onPriceSelect={props.onPriceSelect} />
    </tr>
  );
};

PriceMatrixRow.defaultProps = {
  // leadTimes          : [],
  // hideQuantityCell   : false,
  // rowSpanQuantityCell: 1,
};

PriceMatrixRow.propTypes = {
  groupName: PropTypes.string.isRequired,
  quoteStep: PropTypes.string.isRequired,
  rowSpanQuantityCell: PropTypes.number.isRequired, // rowSpan for first cell
  quantity: PropTypes.number.isRequired,
  hideQuantityCell: PropTypes.bool.isRequired,
  usCombined: PropTypes.object.isRequired,
  parameters: PropTypes.object.isRequired,
  parametersChanged: PropTypes.bool.isRequired,
  onPriceSelect: PropTypes.func.isRequired,
}
export default PriceMatrixRow;
